import React from 'react';
import PropTypes from 'prop-types';
import Field from 'zignal-landscape/lib/Field';
import Label from 'zignal-landscape/lib/Label';
import Select from 'zignal-landscape/lib/Select';
import ToggleSwitch from 'zignal-landscape/lib/ToggleSwitch';
import { THEME_OPTIONS } from '../userFormRules';

const NO_TRANSLATION = { value: null, label: 'Do Not Translate' };

const PreferencesFields = ({ values, onChange, context }) => {
  const { screen, currentUser, accountDetectEnabled, autoTranslationLangOptions = [] } = context;
  const isInternalAdmin = !!currentUser && currentUser.isInternalAdmin === true;
  const langOptions = [NO_TRANSLATION].concat(autoTranslationLangOptions);
  const langValue = langOptions.find((o) => o.value === values.autoTranslationLang) || NO_TRANSLATION;

  return (
    <div>
      {isInternalAdmin && (
        <Field>
          <Label htmlFor="user-form-theme">Theme</Label>
          <div data-cy="user-form-theme">
            <Select
              inputId="user-form-theme"
              isClearable={false}
              isSearchable={false}
              options={THEME_OPTIONS}
              value={THEME_OPTIONS.find((o) => o.value === values.theme) || THEME_OPTIONS[0]}
              onChange={(option) => onChange('theme', option ? option.value : 'light')}
            />
          </div>
        </Field>
      )}

      {screen !== 'mySettings' && (
        <Field>
          <Label htmlFor="user-form-enabled">Active</Label>
          <div data-cy="user-form-enabled">
            <ToggleSwitch id="user-form-enabled" enabled={values.enabled === true} onChange={(e) => onChange('enabled', e.target.checked)} />
          </div>
        </Field>
      )}

      <Field>
        <Label htmlFor="user-form-auto-translation">
          Automatic Translation
          <br />
          <span className="control-label-subtext">(Currently only supported in Detect)</span>
        </Label>
        <div data-cy="user-form-auto-translation">
          <Select
            inputId="user-form-auto-translation"
            isDisabled={!accountDetectEnabled}
            isClearable={false}
            isSearchable={false}
            options={langOptions}
            value={langValue}
            onChange={(option) => onChange('autoTranslationLang', option ? option.value : null)}
          />
        </div>
      </Field>
    </div>
  );
};

PreferencesFields.propTypes = {
  values: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  context: PropTypes.shape({
    screen: PropTypes.string.isRequired,
    currentUser: PropTypes.object.isRequired,
    accountDetectEnabled: PropTypes.bool,
    autoTranslationLangOptions: PropTypes.array,
  }).isRequired,
};

export default PreferencesFields;
